var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 341,
    height: 241,
    viewBox: "0 0 341 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M339.951 30.6527V0.19043H236.222C216.876 0.19043 200.411 16.2449 200.411 36.0041C200.411 49.5886 208.232 60.2915 219.757 67.2896L237.869 76.3458H294.261C319.782 76.3458 339.951 55.7634 339.951 30.6527Z",
    fill: "#50C8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.134 209.723V240.19H211.117H260.1C279.447 240.19 295.912 223.72 295.912 204.784C295.912 191.611 288.709 180.71 277.184 174.123L260.1 165.263L207.824 165.265C182.715 165.265 162.134 185.436 162.134 209.723Z",
    fill: "#50C8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M301.671 107.216L265.448 89.1035L238.693 75.9308L220.581 66.8744C209.056 60.288 201.235 49.1734 201.235 35.5889C201.235 22.0045 216.877 0.598633 236.223 0.598633H226.756C202.882 0.598633 181.889 12.5366 169.128 30.6492C161.308 42.1754 156.368 55.7598 156.368 70.5793C156.368 96.5133 169.952 120.389 195.061 133.15L233.342 152.498L258.039 164.847L276.15 173.904C287.676 180.49 295.497 191.605 295.497 205.189C295.497 218.774 279.855 240.179 260.509 240.179H269.976C293.85 240.179 314.843 228.241 327.603 210.129C335.424 198.603 340.363 185.018 340.363 170.199C339.952 144.265 326.368 120.801 301.671 107.216Z",
    fill: "url(#paint0_linear_26198_23737)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.25 120.804L235.4 0.19043H182.712C163.366 0.19043 145.255 9.65842 134.552 25.3011L68.2812 120.804H159.25Z",
    fill: "url(#paint1_linear_26198_23737)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1018 240.184H41.5255C18.8863 240.184 0.363281 221.659 0.363281 199.43V1.01465H81.0413L159.25 120.805H75.6902L76.1018 240.184Z",
    fill: "url(#paint2_linear_26198_23737)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.021 240.184L75.2822 120.394H158.842L241.989 240.184H151.021Z",
    fill: "url(#paint3_linear_26198_23737)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26198_23737",
    x1: 248.366,
    y1: 0.277135,
    x2: 326.627,
    y2: 240.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484745,
    stopColor: "#0092CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26198_23737",
    x1: 197.225,
    y1: 0.190427,
    x2: 145.71,
    y2: 102.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0092CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26198_23737",
    x1: 18.2113,
    y1: 180.305,
    x2: 89.9008,
    y2: 143.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0092CF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26198_23737",
    x1: 205.382,
    y1: 127.113,
    x2: 151.282,
    y2: 258.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.420848,
    stopColor: "#0092CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50C8FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalto);
export default __webpack_public_path__ + "static/media/salto.b904330386f8eb7beda8c49352cce032.svg";
export { ForwardRef as ReactComponent };